import { useMutation, useQuery } from 'react-query';
import { Loader, Modal, ModalSaveSection } from '../../../../components';
import { sendPandaDocReminder, getPandaDocReminderPreview } from '../../../../fetch';
import { useSnackbar } from 'notistack';
import { Send } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

export const SendReminderModal = ({ pandaDocId, isOpen, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading } = useQuery(
    ['getPandaDocReminderPreview', pandaDocId],
    () => getPandaDocReminderPreview(pandaDocId),
    {
      enabled: isOpen
    }
  );

  const { mutate: sendReminder, isLoading: isDownLoading } = useMutation(
    (id: string) => sendPandaDocReminder(id),
    {
      onSuccess: () => {
        enqueueSnackbar(`Success, email sent.`, {
          variant: 'success'
        });
        onClose();
      },
      onError: (err: any) => {
        enqueueSnackbar(err?.Detail ?? `Error, unable to send reminder, please try again.`, {
          variant: 'error'
        });
      }
    }
  );
  return (
    <Modal open={isOpen} onClose={onClose} title="Send Reminder" maxWidth="md">
      {(isDownLoading || isLoading) && <Loader type="overlay" position="centered" />}
      <Stack mt={1}>
        <Typography>Contract Name: {data?.contractName}</Typography>
        <Typography>Email: {data?.emailToAddress}</Typography>
        <Typography>Subject: {data?.emailSubject}</Typography>
      </Stack>
      <div
        style={{ pointerEvents: 'none' }}
        dangerouslySetInnerHTML={{ __html: data?.emailBody }}
      />
      <ModalSaveSection
        handleSave={() => {
          sendReminder(pandaDocId);
        }}
        handleCancel={onClose}
        saveButtonText="Send Reminder"
        saveButtonIcon={<Send />}
      />
    </Modal>
  );
};
